import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';

import * as MessageApi from '../server/MessageApi';

export const sendBulkEmail = (subject, message, recipients) => {
    const types = {
        request: ActionTypes.EMAIL_SEND_BULK_REQUEST,
        success: ActionTypes.EMAIL_SEND_BULK_SUCCESS,
        failure: ActionTypes.EMAIL_SEND_BULK_FAILURE
    };

    return CentricDispatcher.dispatchAsync(MessageApi.sendBulkEmail(subject, message, recipients), types, {subject, message, recipients});
};

export const removeLastMessage = () => CentricDispatcher.dispatch({type: ActionTypes.MESSAGE_REMOVE});
